import { render } from "./WeeklySummaryList.vue?vue&type=template&id=a8cfa67a&scoped=true"
import script from "./WeeklySummaryList.vue?vue&type=script&lang=js"
export * from "./WeeklySummaryList.vue?vue&type=script&lang=js"

import "./WeeklySummaryList.vue?vue&type=style&index=0&id=a8cfa67a&scoped=true&lang=css"

import exportComponent from "/root/dirif/prod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8cfa67a"]])

export default __exports__